<template>
  <el-dialog
    title="提示信息"
    :visible.sync="dialogWarning"
    top="20%"
    width="420px"
    :lock-scroll=false
    :show-close=false
    :close-on-click-modal=false
    :close-on-press-escape=false
    custom-class="dialog">
    <img style="margin-left: 30px;vertical-align: middle" src="../../assets/imgs/uc_warn.png" alt="">
    <span class="z-font-size-14 z-margin-left-5-precent">{{warningMsg}}</span>
    <span slot="footer" class="dialog-footer">
          </span>
  </el-dialog>
</template>

<script>
  export default {
    props:{
      dialogWarning: { type: Boolean, default:false },
      warningMsg: { type: String, default:'警告' },
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/commons/XdialogWarning.vue